<template>
  <div class="page">
    <h1 class="mt-0 mb-3">Подрядчики</h1>
    <div class="bg-white p-3 el-table">
      <div class="d-flex mb-3">
        <el-input class="mr-2" size="medium" placeholder="Введите наименование подрядчика"
                  v-model="search" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" size="medium" icon="el-icon-plus" @click="showCreateDialog=true"
                   :loading="fetchProgress">
          Добавить
        </el-button>
      </div>

      <div>
        <el-table
          v-loading="fetchProgress"
          ref="table"
          :data="items"
          :row-class-name="tableRowClassName"
          @current-change="onChangeSelected"
          @sort-change="onChangeSort"
          border
          stripe>
          <el-table-column prop="name" label="Наименование" sortable="custom" min-width="300"/>
          <el-table-column prop="isActive" label="Статус" sortable="custom" min-width="200">
            <template slot-scope="scope">
              <span>{{scope.row.isActive ? 'Активный' : 'Неактивный'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="region" label="Регион" sortable="custom" min-width="200"/>
          <el-table-column prop="comment" label="Комментарий" sortable="custom" min-width="400"/>
        </el-table>

        <div class="d-flex justify-content-between mt-4">
          <div class="text-secondary">Всего {{ count }} {{ declOfNum(count, 'подрядчик', 'подрядчика', 'подрядчиков') }}</div>
          <el-pagination
            @current-change="onChangePage"
            :current-page="page"
            :page-size="pageSize"
            :pager-count="5"
            layout="prev, pager, next, slot"
            :total="count">
            <el-select :value="pageSize" @change="setPageSize" size="mini" class="ml-3">
              <el-option v-for="size in [10, 20, 30, 50]" :key="size" :label="size" :value="size"/>
            </el-select>
          </el-pagination>
        </div>
      </div>

      <ContractorCreateDialog v-if="showCreateDialog" :visible.sync="showCreateDialog" />
    </div>
    <ContractorBlock v-if="item" class="mt-4" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { debounce } from 'lodash';
import ContractorBlock from '@/components/contractors/ContractorBlock';
import ContractorCreateDialog from '@/components/contractors/ContractorCreateDialog';
import { declOfNum } from '@/commons/helpers';

export default {
  components: {
    ContractorBlock, ContractorCreateDialog,
  },
  data: () => ({
    showCreateDialog: false,
  }),
  computed: {
    ...mapGetters({
      fetchProgress: 'contractors/fetchProgress',
      actionProgress: 'contractors/actionProgress',
      items: 'contractors/items',
      count: 'contractors/count',
      page: 'contractors/page',
      pageSize: 'contractors/pageSize',
      searchText: 'contractors/searchText',
      itemId: 'contractors/itemId',
      item: 'contractors/item',
    }),

    search: {
      get() {
        return this.searchText;
      },
      set(value) {
        this.setSearchText(value);
        this.debouncedFetchItems();
      },
    },
  },
  methods: {
    ...mapMutations({
      setPage: 'contractors/setPage',
      setSearchText: 'contractors/setSearchText',
      clearState: 'contractors/clearState',
    }),
    ...mapActions({
      fetchItem: 'contractors/fetchItem',
      fetchItems: 'contractors/fetchItems',
      setSort: 'contractors/setSort',
      setPageSize: 'contractors/setPageSize',
      setItemId: 'contractors/setItemId',
    }),
    declOfNum,
    tableRowClassName({ row }) {
      return row.id == this.item?.id ? 'current-row' : '';
    },
    updateUrl() {
      const route = this.$route;
      const query = {
        ...route.query,
        id: this.itemId,
        search: this.searchText,
      };
      // удаляю пустые ключи
      Object.keys(query).forEach((key) => (!query[key] && typeof query[key] !== 'boolean') && delete query[key]);
      this.$router.push({ ...route, query }).catch(() => {});
    },

    onChangeSort({ prop, order }) {
      const propType = {};
      const sortType = propType[prop] || prop;
      const sortDirection = order === 'ascending' ? 'Asc' : order === 'descending' ? 'Desc' : null;
      this.setSort({ sortType, sortDirection });
    },

    onChangePage(page) {
      this.setPage(page);
      this.updateUrl();
      this.fetchItems();
    },

    // eslint-disable-next-line func-names
    debouncedFetchItems: debounce(function () {
      this.setPage(1);
      this.updateUrl();
    }, 500),

    onChangeSelected(item) {
      if (item) {
        this.setItemId(item.id);
        this.updateUrl();
      }
    },
  },

  created() {
    const { id, search } = this.$route.query;
    if (id) {
      this.setItemId(this.$route.query.id);
      this.fetchItem();
    }
    if (search) this.setSearchText(search);
    this.fetchItems();
  },

  destroyed() {
    this.clearState();
  },

  watch: {
    $route: {
      handler(newVal, oldVal) {
        if (newVal.query.id != oldVal.query.id) {
          this.setItemId(newVal.query.id);
          this.fetchItem().then(() => {
            this.$nextTick(() => {
              // eslint-disable-next-line no-unused-expressions
              document.getElementById('contractorBlock')?.scrollIntoView({ behavior: 'smooth' });
            });
          });
        }
        if (newVal.query.search != oldVal.query.search) {
          this.setSearchText(newVal.query.search);
          this.fetchItems();
        }
      },
      deep: true,
    },
  },
};
</script>
